import { getPubAbbr, formatThousand } from "@revbox/helpers-fe";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function ClusterYourBidCellRenderer({ value }) {
  const your_bid = value.split("@")[0];
  const inherited_cpc = value.split("@")[1];
  const cluster_inherited_bid_mode_enabled = value.split("@")[2];
  const status = value.split("@")[3].toUpperCase();

  if (value === "-") {
    return "No bid";
  }

  if (status === "INACTIVE" || status === "DRAFT" || status === "PAUSED") {
    return (
      <div>
        <span className="text-secondary">{your_bid}</span>
      </div>
    )
  }

  if (cluster_inherited_bid_mode_enabled === "true") {
    if (status === "BID ACTIVE" || status === "PAUSED") {
      return (
        <div>
          <span className="text-success fw-bold">{your_bid}</span>
        </div>
      )
    } else if (status === "INHERITED") {
      const cpc = inherited_cpc === "null" ? your_bid : '$' + Number(inherited_cpc.replace('$', '')).toFixed(2);
      return (
        <div>
          <span className="text-secondary">{cpc}</span>
        </div>
      )
    } else {
      return (
        <div>
          <span className="text-secondary">{your_bid}</span>
        </div>
      )
    }
  } else {
    return (
      <div>
        <span className="text-secondary">{your_bid}</span>
      </div>
    )
  }
}

export function YourBidColumnHeaderTooltipRenderer() {
  const publisherId = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherId);
  
  return taxonomy.tooltips.ppc_cluster_column_headers.your_bid;
}

export function ClusterYourBidCellTooltipRenderer({ value }) {
  if (value === '-') return getNoBidTooltip();

  const [yourBidRaw, inheritedCpcRaw, , statusRaw] = value.split('@');
  const yourBid = yourBidRaw.replace('$', '');
  const inheritedCpc = inheritedCpcRaw.replace('$', '');
  const status = statusRaw?.toUpperCase() ?? '';

  const publisherId = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherId);
  const tooltipTemplates = taxonomy.tooltips.ppc_cluster_column_inlines.your_bid;

  // Check if status is explicitly Inactive or Draft (status comes in English)
  if (status === "INACTIVE" || status === "DRAFT") {
    return tooltipTemplates.no_bid;
  }

  // Check if status is explicitly Inherited (status comes in English)
  const isInheritedStatus = status === "INHERITED";
  
  // Only show inherited_bid template if status is explicitly INHERITED
  if (isInheritedStatus) {
    // Use the same logic as cell renderer to determine which bid to show
    // If inherited_cpc is null, fallback to your_bid
    const displayBid = (inheritedCpcRaw === 'null' || !inheritedCpcRaw || inheritedCpcRaw === '$0.00') 
      ? yourBid 
      : inheritedCpc;
    
    if (displayBid && displayBid !== '0.00' && displayBid !== '-') {
      return tooltipTemplates.inherited_bid.replace('{bid}', displayBid);
    }
    return tooltipTemplates.no_bid;
  }

  // For active bids (including BID ACTIVE status)
  if (yourBid && yourBid !== '0.00' && yourBid !== '-') {
    return tooltipTemplates.bid_active.replace('{bid}', yourBid);
  }

  return tooltipTemplates.no_bid;
}

export function formatBid(amount, toEurFn, withThousands = false) {
  const formatted = withThousands ? formatThousand(amount.toFixed(2)) : amount.toFixed(2);
  return `${formatted}${toEurFn(amount)}`;
}

function getNoBidTooltip() {
  const publisherId = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherId);
  return taxonomy.tooltips.ppc_cluster_column_inlines.your_bid.no_bid;
}

